// List of custom functions
// WARNING: THIS FILE IS SHARED TO THE CLIENT

export const customFunctions = [
  {
    source: "custom-outline-to-logline",
    description: "This function converts a 7 step hero's journey outline to a logline",
    name: "Outline to Logline",
    n: 3,
    version: "1",
    stop: ["\n"],
    targetTokens: 200,
    examples: [

`The following is an outline for a story:
Round 1: THE ORDINARY WORLD - goblins undermining royal strategy tonight
Round 2: THE DREAM INSIDE - king decapitated, throne stolen
Round 3: AN UNFAMILIAR SITUATION - sorceress returns, eying vial
Round 4: THE DARKNESS DESCENDS - sorceress is goblin, unsettlingly attractive
Round 5: A HERO RISES - Surprise! Eviscerating lake trout!
Round 6: AFTER THE DUST SETTLES - Gik takes the lake trout fish throne
Round 7: THE LESSON LEARNED - not all heroes have legs
Outline converted to logline:
Living in a world where GOBLINS are on the bottom, they form a rebellion to take the throne. In the battle, the KING is decapitated! But when the SORCERESS returns for the vial, she puts a spell on the King in a plot to retake the kingdom. Revealed to be a GOBLIN herself, Gik turns the table on the sorceress by killing the mythical lake trout, the source of her powers. In doing so, Gik assumed the Lake Trout Fish Throne and decreed to all the land that "not all heroes have legs.`,

// `The following is an outline for a story:
// Round 1: THE ORDINARY WORLD - K.C.E.P.O.    Killing cold evil people out
// Round 2: THE DREAM INSIDE - Done killing, olympics await
// Round 3: AN UNFAMILIAR SITUATION - E.P.K.E.D.    Easy practice, Keeping Everything Disinfected
// Round 4: THE DARKNESS DESCENDS - A. E. F. T.    Aloft Eagles Flash Talons
// Round 5: A HERO RISES - 5 words    javelin right through eagle's brain
// Round 6: AFTER THE DUST SETTLES - Y.A.K.T.    Yet another killing. Typical!
// Round 7: THE LESSON LEARNED - M.R.H.A.    Murders really happed alot
// Outline converted to logline:
// COLD EVIL PEOPLE form a rebellion to take the throne. In the battle, the OLYMPICS are canceled due to the great work of the KILLING COLD EVIL PEOPLE OUT. With EASY PRACTICE, the keeping of EVERYTHING DISINFECTED, the ALOFT EAGLES FLASH TALONS are ready for battle. But when JAVELLIN THROUGH EAGLE'S BRAIN occurs in 5 WORDS, the KING was dethroned. Typical, when MURDERS REALLY HAPPENED ALOT, the people panicked. Well, well, well, in the end, M.R.H.A.`,

`Mr.Floofen the Fat
Round1 [THE ORDINARY WORLD - H.U.N.G.E.R.]
---> winning answer: Huge undulating noodles grab everyone randomly
Round2 [THE DREAM INSIDE - 4 words]
---> winning answer: A noodle free future
Round3 [AN UNFAMILIAR SITUATION - N.O.O.D.S.]
---> winning answer: Noodles open overhead, dooming Stan
Round4 [THE DARKNESS DESCENDS - 7 words]
---> winning answer: light extinguishes; Stan emerges. He is cooking!
Round5 [A HERO RISES - F.A.T.T.Y.]
---> winning answer: Floofen accepts tummy trouble . YUM!
Round6 [AFTER THE DUST SETTLES - 5 words]
---> winning answer: Never want a carb again
Outline converted to logline:
Mr. Floofen the Fat was obsessed with noodles was offered a way to gain control over his mind. He was with a Russian woman who was obsessed with chemistry. She promised him that he could have control over his mind. They were in a dream world. There he found himself in a future where he was noodle-less, skinny, and alone. He stood in the street, nude with people pushing past him, calling him names. The lights in his mind dimmed and went out when he was in a noodle-free future. He came back into the real world, and was skinny. He never wanted to eat carbs again.`,

`Round1 [The Ordinary World - J.E.R.K.]
---> winning answer: Justified entering royal karat
Round2 [The Dream inside - 5 words]
---> winning answer: create the most adorable cat
Round3 [An unfamiliar situation - C.A.T.]
---> winning answer: catnapped! Athena taken!
Round4 [THe darkness descends - 7 words]
---> winning answer: cat teleporting into unopened Schrodingers box sealed
Round5 [A hero rises - B.U.D.D.Y]
---> winning answer: Barkamedes undermines dastardly deed yay
Round6 [after the dust settles - 4 words]
---> winning answer: Barkamedes was Schmuckenstiens creation
Round7 [The lesson learned - B.o.n.e]
---> winning answer: Beware of Not engaging
Outline converted to logline:
Citizens of the Kingdom of Dringenberg are justified entering royal karat, but Dr. Schmuckenstein, seeing the opportunity to increase his fortune, dreamed of creating the most adorable cat. He built prototypes until he had created a magnificent creature, imbued with magical powers. Suddenly, the cats are transported to the Kingdom of Cuteness. A Cat Emperor forms an army of kittens to bring his evil regime to fruition. Schmuckenstein and his apprentice, Barkamedes, thwart the Cat Emperor and restore peace and security. After the dust settles, Schmusckenstein recalls that Barkamedes was his creation all along, learning the lesson that it is best not to play God.`

// `The following is an outline for a story:
// Round 1: people are Justified entering royal karat
// Round 2: As a doctor, Schmuckenstein has a dream inside to create the most adorable cat
// Round 3: After making numerous prototypes, the cats are suddenly teleported away... but where did they go?
// Round 4: The darkness descends when a Cat Emperor forms a kitten Army. Cats will Reign supreme.
// Round 5: Luckily a hero rises, yay! Barkamedes undermines the whole dastardly plot of the Cat Emperor.
// Round 6: After the dust settles, Schmusckenstein recalls that Barkamedes was his creation all along
// Outline converted to logline:
// Rain was forecast for this town, but it did not arrive. Instead, RAINING TARANTULAS did. A VOLATILE PRECIPITATIVE VARIATION, even the barometric pressure was eating people. The big ass tornado that formed killed all the people. The sun was nowhere to be seen. Then, organic matter would eat the tarantulas. He was always over reacting. This man lost the battle.`,


    ],
passageTemplate: `The following is an outline for a story:
$PASSAGE
Outline converted to logline:
`,
    temperature: 0.75,
    users: [
      "seQ43UJFJfPAADPbyYXlzelvWTk2", // jay
      "ht7BG87F3YXaB7z2J6BvmG35ytu1", // scott@wordloops
    ],
    minWords: 10,
    maxWords: 300,
  },

  {
    source: "custom-outline-wormhole",
    description: "This function gives options for the next outline step based on the previous ones",
    name: "Outline Wormhole",
    n: 10,
    version: "1",
    stop: ["\n"],
    targetTokens: 200,
    examples: [

`The following is an hero's journey outline for a story:
Round 1: THE ORDINARY WORLD - goblins undermining royal strategy tonight
Round 2: THE DREAM INSIDE - king decapitated, throne stolen
Round 3: AN UNFAMILIAR SITUATION - sorceress returns, eying vial
Round 4: THE DARKNESS DESCENDS - sorceress is goblin, unsettlingly attractive
Round 5: A HERO RISES - Surprise! Eviscerating lake trout!
Round 6: AFTER THE DUST SETTLES - Gik takes the lake trout fish throne
Round 7: THE LESSON LEARNED - not all heroes have legs`,


`The following is an hero's journey outline for a story:
Round 1: forecast evokes raining tarantulas
Round 2: volatile precipitative variations must end
Round 3: barimetrica pressureson reaps ultimate meals
Round 4: big ass tornado
Round 5: suddenly, organic matter eats tarantulas
Round 6: out came the sun
Round 7: man, over reacting always loses`,

`The following is an hero's journey outline for a story:
Round 1: Odysseus is at home with his wife and son
Round 2:  Odysseus is called to fight the Trojans.
Round 3: He doesn’t want to leave his family.
Round 4: Odysseus’ crew opens the bag of winds when they are nearly home, sending them away again.
Round 5: Odysseus must go to the underworld.
Round 6: Odysseus receives passage home.
Round 7: Odysseus returns home to find his wife is being courted by many suitors.`,

    ],
passageTemplate: `The following is an hero's journey outline for a story:
$PASSAGE
`,
    temperature: 0.75,
    users: [
      "seQ43UJFJfPAADPbyYXlzelvWTk2", // jay
      "ht7BG87F3YXaB7z2J6BvmG35ytu1", // scott@wordloops
    ],
    minWords: 10,
    maxWords: 300,
  },


  {
    source: "custom-story-to-logline",
    description: "This function converts a story to a logline summary",
    name: "Story to Logline",
    n: 3,
    version: "1",
    stop: ["\n"],
    targetTokens: 200,
    examples: [

`The following is a story:
"""
Judith, an orphaned 22-year-old woman with little inheritance, is summoned to a remote seaside house to care for Balthazar, a rich man whose mysterious condition is quickly deteriorating his health. Judith bonds with Balthazar over music, crosswords, and books, but can't convince him to go with her to the sea, even though she knows this will help him. When she finally does convince him, he gets upset, goes back to the house, and insists on taking the laudanum he's only supposed to use as a last resort.
The next day, after snapping at Judith, Balthazar agrees to go to the sea with her again to make up for it. They kiss by the ocean, and then Balthazar tells her she should leave and he rushes off. His condition gets much worse, but Judith doesn't leave.  Eventually, Balthazar tells her he doesn't want her to be there when he changes, and shows her the gills growing on his neck. Judith says she's not afraid and she wants to stay, and as they kiss and embrace again she cries but smiles.
"""
A compelling logline that sums up the story: In a remote seaside house, Judith is hired to be a sick man's caretaker falls in love with him, even as he slowly turns into a sea creature.`,
    ],
passageTemplate: `The following is a story:
$PASSAGE
A compelling logline that sums up the story:`,
    temperature: 0.75,
    users: [
      "seQ43UJFJfPAADPbyYXlzelvWTk2", // jay
      "ht7BG87F3YXaB7z2J6BvmG35ytu1", // scott@wordloops
    ],
    minWords: 10,
    maxWords: 1000,
  },
];

// Clientside class to handle
export class CustomFunctions {
  constructor(userId, isAdmin) {
    if (!userId) {
      throw new Error("Must pass in a valid userId");
    }
    this.userId = userId;
    this.isAdmin = isAdmin;
  }

  list() {
    return customFunctions.filter(func => {
      return this.isAdmin || func.users.includes(this.userId);
    });
  }

}
